(() => {
  'use strict';

  const MAX_WAIT_MS = 25000;
  const CHECK_INTERVAL_MS = 250;
  const READY_SETTLE_MS = 1500;
  const AFTER_CLICK_MS = 1200;

  const path = window.location.pathname || '';

  if (!path.includes('/apps/customify/view/')) {
    return;
  }

  const params = new URLSearchParams(window.location.search);

  const rawTheme = params.get('theme');
  const rawGallery = params.get('mp_gallery');
  const rawThemeSrc = params.get('theme_src');
  const rawThemeId = params.get('theme_id');

  if (
    !rawGallery ||
    (!rawThemeSrc && !rawThemeId && !rawTheme)
  ) {
    return;
  }

  /*
    ==================================================
    PERFORMANCE-METING
    ==================================================

    Alleen logging. Deze code verandert niets aan
    de bestaande Customify-logica of wachttijden.

    performance.now() is het aantal milliseconden
    sinds het begin van deze paginanavigatie.
  */

  const PERF_PREFIX = '[MijnPet performance]';
  const perfMarks = {};

  const markPerformance = (key, detail) => {
    if (Object.prototype.hasOwnProperty.call(perfMarks, key)) {
      return;
    }

    const ms = Math.round(performance.now());
    perfMarks[key] = ms;

    if (detail !== undefined) {
      console.info(`${PERF_PREFIX} ${key}: ${ms} ms`, detail);
    } else {
      console.info(`${PERF_PREFIX} ${key}: ${ms} ms`);
    }
  };

  const printPerformanceSummary = (reason) => {
    const rows = Object.entries(perfMarks).map(
      ([moment, ms]) => ({ moment, ms })
    );

    console.group(`${PERF_PREFIX} OVERZICHT - ${reason}`);
    console.table(rows);
    console.info('Vaste instellingen:', {
      CHECK_INTERVAL_MS,
      READY_SETTLE_MS,
      AFTER_CLICK_MS,
      MAX_WAIT_MS
    });
    console.groupEnd();
  };

  markPerformance('01 loader-script gestart');

  const normalize = (value) => {
    let v = String(value || '')
      .trim()
      .toLowerCase();

    try {
      v = decodeURIComponent(v);
    } catch (error) {
      // Originele waarde behouden.
    }

    v = v
      .split('?')[0]
      .split('#')[0];

    v = v.slice(v.lastIndexOf('/') + 1);

    v = v.replace(
      /\.(png|jpg|jpeg|webp|gif|svg)$/i,
      ''
    );

    if (typeof v.normalize === 'function') {
      v = v
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    }

    return v.replace(/[^a-z0-9]+/g, '');
  };

  const normalizeSource = (value) => {
    let v = String(value || '').trim();

    if (!v) {
      return '';
    }

    try {
      v = decodeURIComponent(v);
    } catch (error) {
      // Originele waarde behouden.
    }

    v = v
      .split('?')[0]
      .split('#')[0];

    try {
      const url = new URL(v, window.location.origin);
      v = url.pathname;
    } catch (error) {
      // Geen geldige URL: oorspronkelijke waarde gebruiken.
    }

    return v
      .slice(v.lastIndexOf('/') + 1)
      .trim()
      .toLowerCase();
  };

  const normalizeId = (value) =>
    String(value || '')
      .trim()
      .replace(/[^0-9]/g, '');

  const normalizeGallery = (value) =>
    String(value || '')
      .trim()
      .toLowerCase();

  const requestedTheme = normalize(rawTheme);
  const requestedSource = normalizeSource(rawThemeSrc);
  const requestedThemeId = normalizeId(rawThemeId);
  const requestedGallery = normalizeGallery(rawGallery);

  if (
    !requestedSource &&
    !requestedThemeId &&
    !requestedTheme
  ) {
    return;
  }

  const style = document.createElement('style');
  style.id = 'mijnpet-theme-loading-style';
  style.textContent = `
    #mijnpet-theme-loading {
      position: fixed;
      inset: 0;
      z-index: 2147483000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
      background: rgba(255, 255, 255, 0.88);
      backdrop-filter: blur(2px);
      -webkit-backdrop-filter: blur(2px);
    }

    #mijnpet-theme-loading-box {
      width: min(420px, 100%);
      padding: 30px 26px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.16);
      text-align: center;
    }

    #mijnpet-theme-loading-spinner {
      width: 42px;
      height: 42px;
      margin: 0 auto 18px;
      border: 4px solid rgba(243, 108, 19, 0.20);
      border-top-color: #F36C13;
      border-radius: 50%;
      animation: mijnpet-theme-spin 0.8s linear infinite;
    }

    #mijnpet-theme-loading-title {
      margin: 0 0 8px;
      font-size: 21px;
      font-weight: 700;
      line-height: 1.25;
      color: #222222;
    }

    #mijnpet-theme-loading-text {
      margin: 0;
      font-size: 15px;
      line-height: 1.5;
      color: #555555;
    }

    #mijnpet-theme-loading-retry {
      display: none;
      margin: 20px auto 0;
      padding: 12px 20px;
      border: 0;
      border-radius: 6px;
      background: #F36C13;
      color: #ffffff;
      font: inherit;
      font-weight: 600;
      cursor: pointer;
    }

    @keyframes mijnpet-theme-spin {
      to {
        transform: rotate(360deg);
      }
    }
  `;

  document.head.appendChild(style);

  const overlay = document.createElement('div');
  overlay.id = 'mijnpet-theme-loading';
  overlay.innerHTML = `
    <div id="mijnpet-theme-loading-box">
      <div
        id="mijnpet-theme-loading-spinner"
        aria-hidden="true"
      ></div>

      <h2 id="mijnpet-theme-loading-title">
        Jouw ontwerp wordt geladen…
      </h2>

      <p id="mijnpet-theme-loading-text">
        Een moment, we plaatsen het gekozen ontwerp op je pet.
      </p>

      <button
        type="button"
        id="mijnpet-theme-loading-retry"
      >
        Opnieuw proberen
      </button>
    </div>
  `;

  document.body.appendChild(overlay);
  markPerformance('02 laadscherm geplaatst');

  const title = document.getElementById(
    'mijnpet-theme-loading-title'
  );

  const text = document.getElementById(
    'mijnpet-theme-loading-text'
  );

  const spinner = document.getElementById(
    'mijnpet-theme-loading-spinner'
  );

  const retryButton = document.getElementById(
    'mijnpet-theme-loading-retry'
  );

  retryButton.addEventListener('click', () => {
    window.location.reload();
  });

  const setStatus = (newTitle, newText) => {
    title.textContent = newTitle;
    text.textContent = newText;
  };

  const removeOverlay = () => {
    markPerformance('11 laadscherm fade gestart');

    overlay.style.transition = 'opacity 0.25s ease';
    overlay.style.opacity = '0';

    window.setTimeout(() => {
      overlay.remove();
      style.remove();

      markPerformance('12 laadscherm verwijderd');
      printPerformanceSummary('succesvolle plaatsing');
    }, 260);
  };

  const showError = () => {
    spinner.style.display = 'none';

    setStatus(
      'Het laden duurt langer dan verwacht',
      'Probeer het opnieuw. Je gekozen ontwerp blijft behouden.'
    );

    retryButton.style.display = 'inline-block';

    markPerformance('99 timeout / foutscherm');
    printPerformanceSummary('timeout');
  };

  const getImageCandidates = () =>
    Array.from(
      document.querySelectorAll(
        '#cst-gallery-widget img.clipartBtn'
      )
    );

  const getCandidateSources = (img) => [
    img.getAttribute('data-src'),
    img.getAttribute('data-original'),
    img.getAttribute('data-lazy-src'),
    img.getAttribute('src'),
    img.currentSrc
  ].filter(Boolean);

  const getCandidateIds = (img) => {
    const item = img.closest('.clipart-item');

    return [
      img.getAttribute('data-id'),
      img.getAttribute('data-file-id'),
      item && item.getAttribute('data-id'),
      item && item.getAttribute('data-file-id')
    ]
      .map(normalizeId)
      .filter(Boolean);
  };

  const findThemeImage = () => {
    const images = getImageCandidates();

    if (!images.length) {
      return null;
    }

    if (requestedSource) {
      const sourceMatches = images.filter((img) =>
        getCandidateSources(img).some(
          (source) =>
            normalizeSource(source) === requestedSource
        )
      );

      if (sourceMatches.length === 1) {
        return sourceMatches[0];
      }

      if (
        sourceMatches.length > 1 &&
        requestedThemeId
      ) {
        const exactIdSourceMatches =
          sourceMatches.filter((img) =>
            getCandidateIds(img).includes(
              requestedThemeId
            )
          );

        if (exactIdSourceMatches.length === 1) {
          return exactIdSourceMatches[0];
        }
      }

      if (sourceMatches.length > 1) {
        console.warn(
          '[MijnPet] Meerdere Customify-afbeeldingen met dezelfde bron gevonden:',
          requestedSource
        );

        return null;
      }
    }

    if (requestedThemeId) {
      const idMatches = images.filter((img) =>
        getCandidateIds(img).includes(
          requestedThemeId
        )
      );

      if (idMatches.length === 1) {
        return idMatches[0];
      }

      if (idMatches.length > 1) {
        console.warn(
          '[MijnPet] Meerdere Customify-afbeeldingen met dezelfde ID gevonden:',
          requestedThemeId
        );

        return null;
      }
    }

    if (requestedTheme) {
      const titleMatches = images.filter((img) => {
        const titleValue =
          img.getAttribute('data-title') || '';

        return (
          normalize(titleValue) ===
          requestedTheme
        );
      });

      if (titleMatches.length === 1) {
        return titleMatches[0];
      }

      if (titleMatches.length > 1) {
        console.warn(
          '[MijnPet] Thema-naam is niet uniek; automatische plaatsing wordt bewust niet uitgevoerd:',
          rawTheme
        );
      }
    }

    return null;
  };

  const imageIsLoaded = (img) =>
    !!(
      img &&
      img.complete &&
      img.naturalWidth > 0 &&
      img.naturalHeight > 0
    );

  const inspectPerformanceMilestones = () => {
    const widget = document.getElementById(
      'cst-gallery-widget'
    );

    if (widget) {
      markPerformance(
        '03 gallery-widget bestaat'
      );
    }

    const selects = [
      document.querySelector('#cst-gallery-cat'),
      document.querySelector('#cst-gallery-cat-sidebar')
    ].filter(Boolean);

    if (selects.length) {
      markPerformance(
        '04 gallery-select bestaat',
        selects.map((select) => ({
          id: select.id,
          value: select.value,
          options:
            select.options
              ? select.options.length
              : 0
        }))
      );
    }

    let targetOptionFound = false;
    let targetSelected = false;

    selects.forEach((select) => {
      if (!select.options) {
        return;
      }

      const option =
        Array.from(select.options)
          .find((item) => {
            return (
              normalizeGallery(
                item.value
              ) === requestedGallery ||
              normalizeGallery(
                item.textContent
              ) === requestedGallery
            );
          });

      if (option) {
        targetOptionFound = true;
      }

      if (
        normalizeGallery(
          select.value
        ) === requestedGallery
      ) {
        targetSelected = true;
      }
    });

    if (targetOptionFound) {
      markPerformance(
        '05 gewenste gallery-optie beschikbaar',
        rawGallery
      );
    }

    if (targetSelected) {
      markPerformance(
        '06 gewenste gallery geselecteerd',
        rawGallery
      );
    }

    const candidates =
      getImageCandidates();

    if (candidates.length > 0) {
      markPerformance(
        '07 eerste logo-items in gallery',
        {
          aantal:
            candidates.length
        }
      );
    }

    const themeImage =
      findThemeImage();

    if (themeImage) {
      markPerformance(
        '08 exact gekozen logo in DOM',
        {
          title:
            themeImage.getAttribute(
              'data-title'
            ),
          dataId:
            themeImage.getAttribute(
              'data-id'
            ),
          src:
            themeImage.getAttribute(
              'src'
            ),
          dataSrc:
            themeImage.getAttribute(
              'data-src'
            )
        }
      );

      if (
        imageIsLoaded(themeImage)
      ) {
        markPerformance(
          '09 exact gekozen logo-afbeelding geladen',
          {
            naturalWidth:
              themeImage.naturalWidth,
            naturalHeight:
              themeImage.naturalHeight
          }
        );
      }
    }
  };

  let finished = false;
  let readyTimerStarted = false;
  let elapsed = 0;
  let pollTimer = null;
  let settleTimer = null;

  const finish = () => {
    finished = true;

    if (pollTimer) {
      window.clearInterval(
        pollTimer
      );

      pollTimer = null;
    }

    if (settleTimer) {
      window.clearTimeout(
        settleTimer
      );

      settleTimer = null;
    }
  };

  const placeTheme = () => {
    if (finished) {
      return;
    }

    inspectPerformanceMilestones();

    const themeImage =
      findThemeImage();

    if (
      !themeImage ||
      !imageIsLoaded(themeImage) ||
      typeof window.jQuery !==
        'function'
    ) {
      readyTimerStarted = false;
      return;
    }

    setStatus(
      'Je ontwerp wordt geplaatst…',
      'Nog heel even, daarna kun je de pet aanpassen.'
    );

    try {
      markPerformance(
        '10 automatische klik op logo uitgevoerd',
        {
          theme: rawTheme,
          themeId: rawThemeId,
          gallery: rawGallery
        }
      );

      window
        .jQuery(themeImage)
        .trigger('click');

      console.info(
        '[MijnPet] Thema automatisch in Customify geladen:',
        {
          theme: rawTheme,
          themeId: rawThemeId,
          themeSrc: rawThemeSrc,
          gallery: rawGallery
        }
      );

      finish();

      window.setTimeout(
        removeOverlay,
        AFTER_CLICK_MS
      );
    } catch (error) {
      console.error(
        '[MijnPet] Fout bij automatisch plaatsen van thema:',
        error
      );

      readyTimerStarted = false;
    }
  };

  pollTimer =
    window.setInterval(() => {
      if (finished) {
        return;
      }

      elapsed +=
        CHECK_INTERVAL_MS;

      inspectPerformanceMilestones();

      const themeImage =
        findThemeImage();

      if (
        themeImage &&
        imageIsLoaded(themeImage) &&
        typeof window.jQuery ===
          'function'
      ) {
        if (!readyTimerStarted) {
          readyTimerStarted = true;

          markPerformance(
            '09b stabilisatietijd gestart',
            {
              READY_SETTLE_MS
            }
          );

          console.info(
            '[MijnPet] Exact thema gevonden en geladen:',
            {
              theme: rawTheme,
              themeId: rawThemeId,
              themeSrc: rawThemeSrc
            }
          );

          settleTimer =
            window.setTimeout(
              placeTheme,
              READY_SETTLE_MS
            );
        }

        return;
      }

      readyTimerStarted = false;

      if (
        elapsed >=
        MAX_WAIT_MS
      ) {
        finish();

        console.warn(
          '[MijnPet] Thema niet tijdig en uniek gevonden:',
          {
            theme: rawTheme,
            themeId: rawThemeId,
            themeSrc: rawThemeSrc,
            gallery: rawGallery
          }
        );

        showError();
      }
    }, CHECK_INTERVAL_MS);
})();